const styles = {
  container: {
    padding: "15px",
    border: "1px solid #ddd",
    borderRadius: "8px",
    maxWidth: "600px",
    margin: "20px auto",
    backgroundColor: "#f9f9f9",
    boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
  },
  list: {
    listStyleType: "none",
    padding: 0,
    margin: 0,
  },
  listItem: {
    padding: "10px",
    borderBottom: "1px solid #e0e0e0",
  },
  logEntry: {
    lineHeight: "1.6",
    color: "#333",
  },
  clearButton: {
    backgroundColor: "#d9534f",
    color: "#fff",
    border: "none",
    padding: "8px 12px",
    borderRadius: "5px",
    cursor: "pointer",
    marginBottom: "10px",
  },
};

export default styles;
